/**
 * We will handle forms here because if there are errors we have to put some magic margins to still have a nice form grid.
 * @module Form
 * @return {Object} public methods.
 */
const Form = (function () {

    function init() {
        var formWithErrors = $('form.has-errors.adjust-grid');
        var grid = $('.standard-form__grid');
        var leftDivs;
        var rightDivs;
        var errorLeftDivs;
        var errorRightDivs;

        if (formWithErrors.length > 0 && grid.length > 0) {
            leftDivs = grid.find('.standard-form__left > div');
            rightDivs = grid.find('.standard-form__right > div');

            for (var i = 0; i < leftDivs.length; i++){
                errorLeftDivs = $(leftDivs[i]).find('.error');
                if (errorLeftDivs.length > 0) {
                    if ($(rightDivs[i])) $(rightDivs[i]).addClass('keep-height');
                }
            }

            for(var j = 0; j < rightDivs.length; j++){
                errorRightDivs = $(rightDivs[j]).find('.error');
                if (errorRightDivs.length > 0) {
                    if ($(leftDivs[j])) $(leftDivs[j]).addClass('keep-height');
                }
            }
        }

        $('input.is-invalid, textarea.is-invalid, select.is-invalid').on('input', onUserInput);
    }

    /**
     * After form validation remove the invalid style from inputs if the values getting changed.
     */
    function onUserInput() {
        $(this).removeClass('is-invalid');
    }

    // Return public methods
    return {
        init: init
    };
})();

window.Form = Form;
export default Form;
